import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { Trip } from '../../classes/trip';

import { BreakpointService } from '../../../core/services/breakpoint.service';

import { SwitcherComponent } from '../switcher/switcher.component';
import { DaterangepickerComponent } from '@sanmanto-sds/ngx-daterangepicker-material';
import { DurationContainerComponent } from './duration-container/duration-container.component';

import dayjs from 'dayjs';
import { Dayjs } from 'dayjs/esm';

@Component({
  selector: 'app-date-range-setting',
  imports: [
    SwitcherComponent,
    DaterangepickerComponent,
    DurationContainerComponent,
  ],
  templateUrl: './date-range-setting.component.html',
  styleUrl: './date-range-setting.component.scss',
})
export class DateRangeSettingComponent implements OnInit {
  @Input() data: Pick<
    Trip,
    'numDays' | 'isSpecifyDates' | 'tripStartDate' | 'tripEndDate'
  > & { showTypeSelector?: boolean };
  @Input() dateLimit: number = 49;
  @Output() payload: EventEmitter<any> = new EventEmitter<any>();

  public isSpecifyDates: boolean;
  public startDate = dayjs(new Date().toDateString());
  public endDate = dayjs(new Date().toDateString());
  public selectedStartDate = null;
  public selectedEndDate = null;
  public duration: number = 12;
  public config = [
    {
      label: 'Dates',
      parameter: true,
    },
    {
      label: 'Duration',
      parameter: false,
    },
  ];
  public min = dayjs(new Date().toDateString());
  public max = dayjs(new Date().toDateString()).add(4, 'day');
  public showTypeSelector = true;

  public breakpointService = inject(BreakpointService);

  public ngOnInit(): void {
    if (
      !this.data.numDays &&
      !this.data.tripEndDate &&
      !this.data.tripStartDate
    )
      this.setupDefaultDates();
    if (this.data.tripStartDate)
      this.startDate = dayjs(new Date(this.data.tripStartDate));

    if (this.data.tripEndDate)
      this.endDate = dayjs(new Date(this.data.tripEndDate));

    if (Object.hasOwnProperty.call(this.data, 'showTypeSelector')) {
      this.showTypeSelector = this.data.showTypeSelector;
      this.data.isSpecifyDates = true;
    }
  }

  public emitValues(): void {
    const payload: {
      isSpecifyDates: boolean;
      numDays?: number;
      tripStartDate?: Date;
      tripEndDate?: Date;
    } = { isSpecifyDates: this.data.isSpecifyDates };
    if (payload.isSpecifyDates && this.selectedStartDate) {
      payload.tripStartDate = this.selectedStartDate.toDate();
      payload.tripEndDate = this.selectedEndDate.toDate();
      this.startDate = this.selectedStartDate;
      this.endDate = this.selectedEndDate;
      this.duration = this.endDate.diff(this.startDate, 'day') + 1;
    } else {
      this.selectedStartDate = null;
      this.selectedEndDate = null;
    }

    payload.numDays = this.duration;
    this.data.numDays = this.duration;
    this.payload.emit(payload);
  }

  public setDate(
    date: Dayjs,
    isEnd: boolean,
    dateRangePickerComponent: DaterangepickerComponent,
  ): void {
    if (this.selectedStartDate && this.selectedEndDate) {
      dateRangePickerComponent.nowHoveredDate = null;
      dateRangePickerComponent.updateCalendars();
    }

    if (isEnd) {
      this.selectedEndDate = date;
      this.emitValues();
    } else {
      this.selectedEndDate = null;
      this.selectedStartDate = date;
    }
  }

  handleSwitcher(isSpecifyDates: boolean): void {
    this.data.isSpecifyDates = isSpecifyDates;
    this.emitValues();
  }

  handleDuration(duration: number) {
    if (typeof duration !== 'number') return;

    this.duration = duration;
    this.data.numDays = duration;
    this.emitValues();
  }

  private setupDefaultDates(): void {
    this.data.tripStartDate = new Date(this.min.toDate());
    this.data.tripEndDate = new Date(this.max.toDate());
    this.data.isSpecifyDates = true;
    this.data.numDays = 12;
    setTimeout(() => this.emitValues(), 250);
  }
}
